import { getOtelReferralFromFileType } from './getOtelReferralFromFileType';
import { getReferralFromSubstrateInfo } from './getReferralFromSubstrateInfo';
export function getOtelReferralFromDocument(document) {
    if (document.substrateInfo) {
        return {
            otelReferral: getReferralFromSubstrateInfo(document.substrateInfo),
            isScdType: true,
        };
    }
    else {
        return {
            otelReferral: getOtelReferralFromFileType(document.fileType),
            isScdType: false,
        };
    }
}
//# sourceMappingURL=getOtelReferralFromDocument.js.map